import i18n from 'i18next';
import dayjs from 'dayjs';
import { initReactI18next } from 'react-i18next';
import localizedFormat from 'dayjs/plugin/localizedFormat';
import translationsEn from '../src/i18n/locales/en/translations.json';
import translationsFi from '../src/i18n/locales/fi/translations.json';
import translationsSwe from '../src/i18n/locales/swe/translations.json';

import 'dayjs/locale/fi';
import { Locale } from './types/ui-types';

dayjs.locale(Locale.FI);
dayjs.extend(localizedFormat);

i18n.use(initReactI18next).init({
  fallbackLng: Locale.FI,
  lng: Locale.FI,
  resources: {
    en: {
      translations: translationsEn,
    },
    fi: {
      translations: translationsFi,
    },
    swe: {
      translations: translationsSwe,
    },
  },
  ns: ['translations'],
  defaultNS: 'translations',
});

i18n.languages = [Locale.FI, Locale.EN, Locale.SWE];

export default i18n;
